import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  Output,
  EventEmitter,
  ViewRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core'
import { FormControl } from '@angular/forms'
import { Subscription } from 'rxjs'
import { MaskFieldService } from '../services/mask-field.service'

const MASK_LIB = true

export interface IMaskFieldLog {
  userName: string
  function: string
  system: string
  referenceType: string
  referenceNumber: string
  dataPrivacyField: string
  dataPrivacyMaskingValue: string
  locationCd?: string
  sqlStatement?: string
  accessDate?: string
  accessDataBase?: string
  caNumber?: string
}

@Component({
  standalone: false,
  selector: 'myais-mask-field',
  templateUrl: './single-mask-field.component.html',
  styleUrls: ['./single-mask-field.component.scss'],
  providers: [MaskFieldService]
})
export class SingleMaskFieldComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @Input() parent: boolean = false
  @Input() userName: string = ''
  @Input() function: string = ''
  @Input() system: string = ''
  @Input() referenceType: string = ''
  @Input() referenceNumber: string = ''

  @Input() locationCd: string = ''
  @Input() sqlStatement: string = ''
  @Input() accessDataBase: string = ''
  @Input() caNumber: string = ''

  @Input() labelSize!: string
  @Input() labelColor!: string
  @Input() labelWeight!: string
  @Input() labelStyle!: string
  @Input() fieldSize!: string
  @Input() fieldColor!: string
  @Input() fieldWeight!: string
  @Input() fieldStyle!: string
  @Input() fieldControl!: string

  @Input() label!: string
  @Input() type!: string
  @Input() canEdit: string = 'no'

  @Input() showAsRow: boolean = true
  @Input() hasDataPrivacy: boolean = false;
  @Input() isMultipleRef: boolean = false

  @Input() eventName: string = ''
  @Output() evEditData: EventEmitter<any> = new EventEmitter()

  @ViewChild('elLabel') labelElement!: ElementRef
  @ViewChild('elField') fieldElement!: ElementRef
  @ViewChild('elEyeImg') eyeElement!: ElementRef
  @ViewChild('elInput') inputElement!: ElementRef

  fmEditText!: FormControl
  fmEditText$!: Subscription
  _uiText: string = ''
  _canUnmask: number = -1 // -1: unset, 1: can unmask, 0: cannot unmask
  editText!: string
  inputText!: string
  inputObj: any = null
  maskText!: string
  isValidType: boolean = false
  resFieldType: number = 0
  showEye: boolean = true
  hideLabel: boolean = false
  setMask: boolean = true
  eyeClicked: boolean = false
  isEditState: boolean = false
  insideMultiMask: boolean = false
  destroyed: boolean = false
  invalidRequiredInputList: any = []
  _underLine!: boolean

  dataRefFlagIdx!: number;

  @Input() set text(inputData: any) {
    const s = this.type.split(',')
    if (s.length == 1) {
      let inputText: string
      if (typeof inputData === 'object') {
        this.inputObj = inputData
        inputText = this.getObjecText(this.type, inputData)
      } else {
        inputText = inputData
      }

      this.resFieldType = this.maskFieldService.validateFieldType(this.type)
      if (this.resFieldType > 0) {
        const maskObj = this.maskFieldService.getMaskText(
          this.type,
          inputText,
          true
        )

        this.maskText = maskObj[0].mask
        this._uiText = this.getDisplayText(true)
        this.inputText = maskObj[0].text
      } else {
        this.canEdit = this.resFieldType === -1 ? 'no' : this.canEdit
        this.inputText =
          this.resFieldType === 0 ? inputText : 'Invalid field type'
        this._uiText = this.inputText
      }
      this.editText = this.getPlainText(this.inputText)
    } else {
      const maskObj = this.maskFieldService.getMaskText(
        this.type,
        inputData,
        true
      )

      if (maskObj.length > 0) {
        this.maskText = maskObj.map(item => item.mask).join(',')
      }
    }
  }

  get text(): any {
    return this._uiText
  }

  @Input() set canUnmask(cUnmask: boolean) {
    this._canUnmask = cUnmask ? 1 : 0
  }

  get canUnmask(): boolean {
    return this._canUnmask === 1
  }

  @Input() set underLine(underLine: boolean) {
    this._underLine = underLine && underLine === true ? true : false
  }

  @Input() set dataRefIndex(index: number) {
    this.dataRefFlagIdx = index
  }
  @Input() set dataRefFlag(index: string) {
    if (index.length == 0) {
      return
    }
    const s = index.split('-')
    if (s.length != 2) {
      return
    }
    const idx = Number(s[1])
    if (this.dataRefFlagIdx == idx) {
      this.onClickMultipleRef();
    }
  }

  constructor(
    private elRef: ElementRef,
    private maskFieldService: MaskFieldService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.insideMultiMask = this.elRef.nativeElement.parentElement === null
    this.validateRequiredInputs(this.insideMultiMask)
    if (!this.insideMultiMask) {
      document.addEventListener('click', this.handleOnClick.bind(this))
      this.canUnmask = this.canUnmask && this.inputText !== this.maskText
    }
  }

  measureTextPixel(rect:any, text:any, fontInfo:any) {
    const canvas = document.createElement('canvas')
    let ctx:any = canvas.getContext('2d')
    const body = document.getElementsByTagName('body')[0]
    let textPixel
    let reservedSpace

    canvas.width = rect.right - rect.left
    canvas.height = rect.bottom - rect.top
    canvas.style.position = 'absolute'

    body.appendChild(canvas)
    ctx = canvas.getContext('2d')
    ctx.font = fontInfo // "30px Arial";
    textPixel = ctx.measureText(text).width
    reservedSpace = ctx.measureText('WW').width // reserve 2-char space next to mask text before draw icon
    canvas.remove()
    return [textPixel, reservedSpace]
  }

  initEyeIconPosition() {
    const elInput = this.inputElement.nativeElement
    const elIcon = this.eyeElement.nativeElement

    if (this.insideMultiMask) {
      console.log(elInput.parentElement.style)
      if (MASK_LIB) {
        elInput.parentElement.style.paddingLeft = '10px'
      }
      elIcon.style.display = 'none'
      return
    }

    const inputRect = elInput.getBoundingClientRect()
    const iconRect = elIcon.getBoundingClientRect()
    const fontFamily = getComputedStyle(elInput).getPropertyValue('font-family')
    const fontSize = getComputedStyle(elInput).getPropertyValue('font-size')
    const [textPixel, reservedSpace] = this.measureTextPixel(
      inputRect,
      elInput.value,
      fontSize + ' ' + fontFamily.replace(/\"/g, '')
    )
    const inputCenter = (inputRect.bottom - inputRect.top) / 2
    let iconCenter = 0

    elIcon.style.width = (inputRect.bottom - inputRect.top) * 0.8 + 'px'

    iconCenter =
      parseInt(getComputedStyle(elIcon).getPropertyValue('height')) / 2
    // console.log(inputRect, iconRect, elInput.left, elInput.top);
    elIcon.style.top = inputCenter - iconCenter + 'px'

    if (!MASK_LIB) {
      // client-easy-app
      elIcon.style.top = inputCenter - iconCenter + 'px'
      if (
        inputRect.left + textPixel + reservedSpace + iconRect.width <
        inputRect.right
      ) {
        elIcon.style.left = textPixel + reservedSpace + 'px'
      } else {
        // console.log("Icon is out bound!");
      }
    } else {
      // client-customer-info-portal (lib)

      if (
        inputRect.left + textPixel + reservedSpace - 10 + iconRect.width <
        inputRect.right
      ) {
        // 10 -> input style:text-indent
        elIcon.style.left = textPixel + reservedSpace - 10 + 'px'
      } else {
        // console.log("Icon is out bound!", parseInt(elInput.style.textIndent), elInput);
        elIcon.style.left =
          inputRect.width - iconRect.width - reservedSpace / 2 + 'px'
        elInput.style.width = elIcon.style.left
      }
    }
  }

  ngAfterViewInit() {
    this.setAttributes()
    if (this.fieldControl === 'INPUT') {
      // && !this.insideMultiMask) {
      this.initEyeIconPosition()
    }
  }

  ngOnDestroy(): void {
    this.destroyed = true
    this.cd.detach()
    if (this.fmEditText$) {
      this.fmEditText$.unsubscribe()
    }
  }

  onClickField(event:any) {
    event.stopPropagation()
    if (this.evEditData) {
      this.evEditData.emit(this.getEmitData())
    }

    if (!this.destroyed) {
      this.cd.detectChanges()
    }
  }

  handleOnClick(event:any) {
    // If lose focus set mask on
    if (this.eyeClicked) {
      this.eyeClicked = this.setMask
    } else {
      this.setMask = true
      if (this.inputText) {
        this.setMaskText()
      }
    }
    // if(!this.cd['destroyed']){
    if (!this.destroyed) {
      this.cd.detectChanges()
    }
  }

  setInsideMultiMask() {
    this.insideMultiMask = true
  }

  canEmitEvent(): boolean {
    return this.canEdit !== 'no'
  }

  setCanUnmask(cUnmask: boolean) {
    if (this._canUnmask === -1) {
      // can over write if canUnmask never defined
      this._canUnmask = cUnmask ? 1 : 0
    }
  }

  disableCanEdit() {
    this.canEdit = 'no'
  }

  validateRequiredInputs(insideMultiMask: boolean) {
    if (!insideMultiMask) {
      if (!this.userName.length) {
        this.invalidRequiredInputList.push('[userName]=userName is required')
      }
      if (!this.function.length) {
        this.invalidRequiredInputList.push('[function]=function is required')
      }
      if (!this.system.length) {
        this.invalidRequiredInputList.push('[system]=system is required')
      }
      if (!this.referenceType.length) {
        this.invalidRequiredInputList.push(
          '[referenceType]=referenceType is required'
        )
      }
      if (!this.referenceNumber.length) {
        this.invalidRequiredInputList.push(
          '[referenceNumber]=referenceNumber is required'
        )
      }
      if (!this.text.length && !Object.keys(this.text).length) {
        this.invalidRequiredInputList.push('[text]=text is required')
      }

      if (this.invalidRequiredInputList.length) {
        this._uiText = this.invalidRequiredInputList.toString()
        this.inputText = ''
        this.canEdit = 'no'
        this.canUnmask = false
      }
    } else {
      if (!this.text) {
        this._uiText = '[text]=text is required'
        this.inputText = ''
        this.canEdit = 'no'
        this.invalidRequiredInputList.push('[text]=text is required')
      }
    }
    if (this.maskFieldService.validateFieldType(this.type) === -1) {
      this.invalidRequiredInputList.push('Invalid field type')
    }
  }

  getObjecText(type: string, objData: any): string {
    let text: string = ''
    switch (type) {
      case 'FULLNAME':
        text = this.getDisplayFullname(objData)
        break
      case 'ADDRESS':
        text = this.getDisplayAddress(objData)
        break
    }
    return text
  }

  getEmitData(): any {
    return {
      eventName: this.eventName,
      type: this.type,
      data: this.inputObj ? this.inputObj : this.inputText
    }
  }

  setLabelAttributes(color:any, size:any, weight:any, style:any) {
    if (color) {
      this.labelColor = color
    }
    if (size) {
      this.labelSize = size
    }
    if (weight) {
      this.labelWeight = weight
    }
    if (style) {
      this.labelStyle = style
    }
  }

  setFieldAttributes(color:any, size:any, weight:any, style:any) {
    if (color) {
      this.fieldColor = color
    }
    if (size) {
      this.fieldSize = size
    }
    if (weight) {
      this.fieldWeight = weight
    }
    if (style) {
      this.fieldStyle = style
    }
  }

  doSetMaskFlag(setMask: boolean) {
    this.setMask = setMask
  }

  onClickEyeIcon() {
    this.eyeClicked = true
    this.setMask = !this.setMask
    this.setMask ? this.setMaskText() : this.unmaskText(true)
  }

  onClickPenIcon(isInputEdit: boolean) {
    if (isInputEdit) {
      this.isEditState = !this.isEditState
      if (this.isEditState) {
        this.fmEditText = new FormControl(this.editText)
        this.fmEditText$ = this.fmEditText.valueChanges.subscribe(async () => {
          this.editText = this.fmEditText.value
          const maskObj = this.maskFieldService.getMaskText(
            this.type,
            this.editText
          )

          if (maskObj.length == 1) {
            this.maskText = maskObj[0].mask
            this.inputText = maskObj[0].text
          }
        })
      } else {
        this._uiText = this.setMask ? this.maskText : this.inputText
        if (this.canEmitEvent()) {
          this.evEditData.emit(this.getEmitData())
        }
      }
    } else {
      if (this.canEmitEvent()) {
        this.evEditData.emit(this.getEmitData())
      }
    }
  }

  setMaskText() {
    this._uiText = this.getDisplayText(true)
  }

  async unmaskText(addLog: boolean) {
    this._uiText = this.getDisplayText(false)

    if (
      addLog &&
      this.canUnmask &&
      this.resFieldType === 1 &&
      this.type !== 'ADDRESS'
    ) {
      let logReqData: IMaskFieldLog
      logReqData = {
        userName: this.userName,
        function: this.function,
        system: this.system,
        dataPrivacyField: this.maskFieldService.getFieldName(this.type),
        dataPrivacyMaskingValue: this.maskText,
        referenceType: this.referenceType,
        referenceNumber: this.referenceNumber,
        locationCd: this.locationCd || '',
        sqlStatement: this.sqlStatement || '',
        accessDataBase: this.accessDataBase || '',
        caNumber: this.caNumber || ''
      }
      await this.maskFieldService.addLog(logReqData)
    }
  }

  setAttributes() {
    if (this.labelColor) {
      this.labelElement.nativeElement.style.color = this.labelColor
    }
    if (this.labelSize) {
      this.labelElement.nativeElement.style.fontSize = this.labelSize
    }
    if (this.labelWeight) {
      this.labelElement.nativeElement.style.fontWeight = this.labelWeight
    }
    if (this.labelStyle) {
      this.labelElement.nativeElement.style.fontStyle = this.labelStyle
    }

    if (this.fieldColor) {
      this.fieldElement.nativeElement.style.color = this.fieldColor
    }
    if (this.fieldSize) {
      this.fieldElement.nativeElement.style.fontSize = this.fieldSize
    }
    if (this.fieldWeight) {
      this.fieldElement.nativeElement.style.fontWeight = this.fieldWeight
    }
    if (this.fieldStyle) {
      this.labelElement.nativeElement.style.fontStyle = this.fieldStyle
    }
  }

  getPlainText(text: string): string {
    let resultText = text
    switch (this.type) {
      case 'MSISDN':
        resultText = text.replace(/-/g, '')
        break
    }
    return resultText
  }

  getDisplayText(isMask: boolean) {
    let text = ''
    switch (this.type) {
      case 'FULLNAME':
        if (this.inputObj && this.resFieldType === 1) {
          // valid type
          text = this.inputObj.titleName || ''
        }
        text += isMask && this.maskText ? this.maskText : this.inputText
        break
    }
    if (!text.length) {
      if (isMask) {
        text = this.resFieldType === 1 ? this.maskText : this.inputText
      } else {
        text = this.canUnmask && this.inputText ? this.inputText : this._uiText
      }
    }
    return text.length ? text : this._uiText
  }

  getDisplayFullname(objData:any) {
    return objData.firstName + ' ' + objData.lastName
  }

  fillUpAddress(address: any): string {
    let fullAddress: string = address.homeNo
    fullAddress += address.buildingName ? ' ตึก ' + address.buildingName : ''
    fullAddress += address.floor ? ' ชั้น ' + address.floor : ''
    fullAddress += address.room ? ' ห้อง ' + address.room : ''
    fullAddress += address.moo ? ' หมู่ที่ ' + address.moo : ''
    fullAddress += address.mooBan ? ' หมู่บ้าน ' + address.mooBan : ''

    fullAddress += address.soi ? ' ซอย ' + address.soi : ''
    fullAddress += address.street ? ' ถนน ' + address.street : ''
    fullAddress += address.tumbol ? ' ตำบล/แขวง ' + address.tumbol : ''
    fullAddress += address.amphur ? ' อำเภอ/เขต ' + address.amphur : ''
    fullAddress += address.province ? ' จ.' + address.province : ''
    fullAddress += address.postCode ? ' ' + address.postCode : ''
    return fullAddress
  }

  getDisplayAddress(addrData: any) {
    if (addrData) {
      const {
        province,
        amphur,
        tumbol,
        postCode,
        street,
        soi,
        homeNo,
        moo,
        mooban,
        room,
        floor,
        buildingName
      } = addrData
      return this.fillUpAddress({
        province,
        amphur,
        tumbol,
        postCode,
        street,
        soi,
        homeNo,
        moo,
        mooBan: mooban,
        room,
        floor,
        buildingName
      })
    } else {
      return '-'
    }
  }

  onClickMultipleRef() {
    if (this.hasDataPrivacy) {
      let logReqData: IMaskFieldLog
      logReqData = {
        userName: this.userName,
        function: this.function,
        system: this.system,
        dataPrivacyField: this.maskFieldService.getFieldName(this.type),
        dataPrivacyMaskingValue: this.maskText,

        referenceType: this.referenceType,
        referenceNumber: this.referenceNumber,
        locationCd: this.locationCd || '',
        sqlStatement: this.sqlStatement || '',
        accessDataBase: this.accessDataBase || '',
        caNumber: this.caNumber || ''
      }
      this.maskFieldService.addLog(logReqData)
      //console.log(logReqData)
    }
  }
}
